import { createSessionStorageSync } from './use-session-storage-sync'

export type PaymentMethodsTab = 'cards' | 'banks'

// タブはセッション内の「今の文脈」 として sessionStorage で保持。
// ブラウザを閉じたらリセットし、 次回起動時は cards (デフォルト) から始まる。
// 詳細ページから戻った時など、 同じセッション内では選択が維持される。
export const usePaymentMethodsTab = createSessionStorageSync<PaymentMethodsTab>(
  'tab.payment-methods',
  'cards',
  (raw) => (raw === 'cards' || raw === 'banks' ? raw : null),
)
